import React, { useEffect, useMemo } from "react";
import objectPath from "object-path";
import { KTUtil } from "../../../_metronic/_assets/js/components/util.js";
import history from "../../../utils/history";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";

export function OnBoardLayout(props) {
  const { children, location } = props;

  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        "header.self.fixed.desktop"
      ),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);

  const renderRoutes = () => {
    if (
      location.pathname.includes("/signup/") &&
      !location.pathname.includes("/signup/plans") &&
      !KTUtil.isMobileDevice()
    ) {
      return (
        <div
          className={`login login-1 login-signin-on d-flex flex-column flex-lg-row ${
            KTUtil.isMobileDevice() ? "login-bg" : "w-100"
          }`}
          id="kt_login"
        >
          <div
            className={`d-flex flex-column flex-row-fluid position-relative overflow-hidden ${
              KTUtil.isMobileDevice() ? "p-7" : ""
            }`}
          >
            <div className="d-flex flex-column-fluid flex-center mt-lg-0">
              {children}
            </div>
          </div>
        </div>
      );
    } else if (
      location.pathname.includes("/signup/") && location.pathname.includes("/signup/client-info/") && KTUtil.isMobileDevice()
    ) {
      return <div className={`container primary-bg`}> {children}</div>;
    } else if (location.pathname.includes("/signup/") && location.pathname.includes("/signup/steps") && KTUtil.isMobileDevice()) {
      return <div className={`container`}>{children}</div>;
    } else {
      return <div className={`container p-15`}>{children}</div>;
    }
  };

  return layoutProps.selfLayout !== "blank" ? (
    <>
      <div className="d-flex flex-column flex-root">
        <div className="d-flex flex-row flex-column-fluid page on-board-bg">
          {/*begin::Entry*/}
          {!layoutProps.contentExtended && renderRoutes()}
          {layoutProps.contentExtended && { children }}
        </div>
      </div>
    </>
  ) : (
    // BLANK LAYOUT
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
